export default {
  title: 'Популярные экскурсии',
  showMore: 'Показать ещё',
} as const;
